"use client";

import Button from "@/components/Button";
import React, { useState } from "react";
import { ModalType } from "..";
import { AnimatePresence } from "framer-motion";
import dynamic from "next/dynamic";
import TextBlock from "@/components/TextBlock";
import OnlineIcon from "@/public/assets/images/online.svg";
import Text from "@/components/Text";
import { transformText } from "@/utils/transformText";
import GradientLightText from "@/components/GradientLightText";
import CustomImage from "@/components/CustomImage";

const DynamicModal = dynamic(() => import("@/components/Modal"), {
  ssr: false,
});

type ReadMoreButtonProps = {
  text: string;
  modal: ModalType;
};

const ReadMoreButton = ({ text, modal }: ReadMoreButtonProps) => {
  const [active, setActive] = useState(false);

  return (
    <>
      <Button
        type="secondary"
        onClick={() => {
          setActive(true);
          document.body.classList.add("no-scroll");
        }}
      >
        {text}
      </Button>
      <AnimatePresence initial={false} onExitComplete={() => null}>
        {active && modal ? (
          <DynamicModal
            isDarkerFull
            handleClose={() => {
              setActive(false);
              document.body.classList.remove("no-scroll");
            }}
          >
            <div className="bali-online__modal">
              <div className="bali-online__modal-holder">
                <div className="bali-online__modal-left">
                  <TextBlock>
                    <div className="bali-online__modal-title-and-icon">
                      <OnlineIcon />
                      <Text
                        element="h3"
                        elementStyle="subtitle"
                        fontFamily="noto-serif"
                        className="weight-700"
                      >
                        {transformText(modal.title, {
                          gradient: (chunk) => (
                            <GradientLightText element="span">
                              {chunk}
                            </GradientLightText>
                          ),
                        })}
                      </Text>
                    </div>
                    <ul className="bali-online__modal-list">
                      {modal.items.map((item) => (
                        <Text
                          key={item}
                          element="li"
                          elementStyle="body"
                          className="weigth-500 bali-online__modal-item"
                          fontFamily="noto-serif"
                        >
                          {item}
                        </Text>
                      ))}
                    </ul>
                    <Text
                      element="p"
                      elementStyle="subtitle"
                      fontFamily="noto-serif"
                      className="weight-700"
                    >
                      {modal.subtitle}
                    </Text>
                    <Text
                      element="p"
                      elementStyle="body"
                      fontFamily="noto-serif"
                      className="weight-500"
                    >
                      {modal.text}
                    </Text>
                    <div className="bali-online__modal-price-and-text">
                      <Text
                        element="p"
                        elementStyle="subtitle"
                        className="weight-700"
                        fontFamily="noto-serif"
                      >
                        {transformText(modal.priceText, {
                          gradient: (chunk) => (
                            <GradientLightText element="span">
                              {chunk}
                            </GradientLightText>
                          ),
                        })}
                      </Text>
                      <Button type="primary">{modal.button.text}</Button>
                    </div>
                  </TextBlock>
                </div>
                <div className="bali-online__modal-right">
                  <CustomImage
                    alt={modal.image.alt}
                    src={modal.image.src.desktop}
                    srcTablet={modal.image.src.tablet}
                    srcMobile={modal.image.src.mobile}
                  />
                </div>
              </div>
            </div>
          </DynamicModal>
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default ReadMoreButton;
